import { $$ } from '@suntex.core/text'
import { removePrefix } from '@suntex.core/text/transforms'
import {
  $ArithmeticOperation,
  $JtfMode,
  $SkillSetLevel
} from '@suntex.fim/enums'
import { useModules } from '@suntex.fim/framework'

import { initializeGameHost } from '../Shared/gameUtils'

import { BonusGames } from './BonusGames'
import { JustTheFacts } from './JustTheFacts'
import { SkillSet } from './SkillSets'
import { SkillSetGame } from './skillSetsUtils'

declare global {
  interface Window {
    toQueryString(qs: object): string
    fromQueryString(qs: string): object
    enumValues<TEnum>(enumType: TEnum): TEnum[]
  }
}

class Patterns {
  static preview = String.raw`(/?<preview>preview)?`
}

interface ILoadingProps {
  kind?: string
}

export function Loading(props: ILoadingProps) {
  return <div>Loading.... (Waiting for {props.kind})</div>
}

export function Module() {
  initializeGameHost()

  //this will ensure that modules are loaded
  const modules = useModules()
  if (!modules) return <Loading />

  const path = $$(window.location.pathname, [
    removePrefix('/'),
    removePrefix('modules'),
    removePrefix('module')
  ])

  const rgxArithmeticOperationSlug = `(?<arithmeticOperationSlug>${$ArithmeticOperation
    .describeAll()
    .map((m) => m.slug)
    .join('|')})`

  function toRegExp(pattern: string): RegExp {
    return new RegExp(pattern.replace(/[\s\r\n]/gi, ''), 'gi')
  }

  const rgxSkillsets = toRegExp(String.raw`
        ${Patterns.preview}
        /(skillsets|ss)
        /(?<level>[1-8])
        /(?<game>[1-3])
        `)

  //try ss match
  let match = rgxSkillsets.exec(path)
  if (match) {
    const level = $SkillSetLevel.from(parseInt(match.groups!.level, 10))
    const game = parseInt(match.groups!.game, 10) as SkillSetGame
    return <SkillSet level={level} game={game} />
  }

  const rgxJustTheFacts = toRegExp(String.raw`
        ${Patterns.preview}
        /just-the-facts
        /(?<jtfModeSlug>${$JtfMode
          .describeAll()
          .map((m) => m.slug)
          .join('|')})
        /${rgxArithmeticOperationSlug}
        `)

  //try jtf match
  match = rgxJustTheFacts.exec(path)
  if (
    match &&
    match.groups!.jtfModeSlug &&
    match.groups!.arithmeticOperationSlug
  ) {
    const jtfMode = $JtfMode.fromSlug(match.groups!.jtfModeSlug)
    const arithmeticOperation = $ArithmeticOperation.fromSlug(
      match.groups!.arithmeticOperationSlug
    )
    return (
      <JustTheFacts
        jtfMode={jtfMode}
        arithmeticOperation={arithmeticOperation}
      />
    )
  }

  const rgxBonusGames = toRegExp(String.raw`
        ${Patterns.preview}
        /(bonus-games|games)
        /(?<slug>[\w-]+)
        `)

  //try bonus match
  match = rgxBonusGames.exec(path)
  if (match) {
    return <BonusGames slug={match.groups!.slug} />
  }

  //got here, so no match
  return <div>The url {window.location.href} is not currently supported.</div>
}

export default Module
